module.exports = __webpack_public_path__ + "static/healthcare-8a249b0cda15532624160b834192fa13.jpg";